// import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Component, ViewChild, AfterViewInit, NgModule, Inject, OnInit} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import {merge, Observable, of as observableOf} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';
import { BrowserModule } from '@angular/platform-browser';
import { HttpService } from '../../http.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar} from '@angular/material/snack-bar';
import { AuthenticationService } from '../../_services';
import { EntradaService } from '../../_services';
import { ReportService } from '../../_services';
import { first } from 'rxjs/operators';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { environment } from 'src/environments/environment';

interface FulfillmentStatus {
  value: string;
  viewValue: string;
}

interface EstadosDevolucionesEntradas {
  value: string;
  viewValue: string;
  
}
interface EstadosTickets {
  value: number;
  viewValue: string;
  
}
interface EstadosProductos {
  value: number;
  viewValue: string;
  
}
interface EstadosStock {
  value: number;
  viewValue: string;
  
}
interface Canales {
  value: string;
  viewValue: string;
  
}
interface EstadosPublicaciones {
  value: String;
  viewValue: string;
  
}
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {

  current_user: any;
  
  constructor(
    private authenticationService: AuthenticationService
  ) { }

  ngOnInit() {
    this.asignarDatos();
  }
  asignarDatos(){
    this.current_user = this.authenticationService.currentUserValue
    
  }
  validar_roles(clave_modulo){
    return this.authenticationService.validar_roles(clave_modulo,this.current_user.permisos);  
  }

}


@Component({
  selector: 'reports-tab-1',
  templateUrl: './reports-tab-1.html',
  styleUrls: ['./reports.component.scss']

})
export class ReportsTab1 implements AfterViewInit {
  checkProductosInavtivos = false;
  labelPositionCheckbox = 'before';

  displayedColumns: string[] = [
                                  'id', 
                                  'filtro',
                                  'pagado', 
                                  'fecha_emision', 
                                  'fecha_vencimiento',
                                ];

ff_status: FormControl;
estatus_entrada_devolucion: FormControl;
picker_inicio: string;
fecha: string;
picker_fin: string;
nombre_seller:FormControl;
estatus_tickets: FormControl;
estatus_productos: FormControl;
estatus_stock: FormControl;
estatus_publicacion: FormControl;
canal_seleccionado: FormControl;

addEvent2(type: string, event: MatDatepickerInputEvent<Date>) {
  this.picker_inicio = event.value.toLocaleDateString('en-GB'); // British English uses day-month-year order
}

addEvent3(type: string, event: MatDatepickerInputEvent<Date>) {
  this.picker_fin = event.value.toLocaleDateString('en-GB'); // British English uses day-month-year order
}

fulfillment_status: FulfillmentStatus[] = [
  {value: 'unfulfilled_bo', viewValue: 'Backorders'},
  {value: 'cancelado', viewValue: 'Cancelado'},
  {value: 'fulfilled', viewValue: 'Fulfilled'},
  {value: 'pausado', viewValue: 'Pausado'},
  {value: 'unfulfilled', viewValue: 'Unfulfilled'},
];

estados_entradas_devolucion: EstadosDevolucionesEntradas[] = [
  {value: 'abierta', viewValue: 'Abierta'},
  {value: 'en_proceso', viewValue: 'En proceso'},
  {value: 'closed', viewValue: 'Cerrada'},
  {value: 'reabierta', viewValue: 'Re-abierta'},
  {value: 'en_revision', viewValue: 'En Revisión'},
  {value: 'pausada', viewValue: 'Pausada'},
  {value: 'cancelada', viewValue: 'Cancelada'},
];
estados_tickes : EstadosTickets[] =[
  {value: 1, viewValue: 'Abierta'},
  {value: 2, viewValue: 'Cerrada'},
  {value: 3, viewValue: 'Re-abierto'},
];

estados_productos : EstadosProductos[] =[
  {value: 1, viewValue: 'Activo'},
  {value: 2, viewValue: 'Pausado'},
];

estados_stock : EstadosStock[] =[
  {value: 1, viewValue: 'Con Stock'},
  {value: 2, viewValue: 'Sin Stock'},
];

estados_publicaciones : EstadosPublicaciones[] =[
  {value: 'Activo', viewValue: 'Activo'},
  {value: 'Inactivo', viewValue: 'Inactivo'},
];

canales: Canales[] = [
  {value: 'Liverpool', viewValue: 'Liverpool'},
  {value: 'Shopify', viewValue: 'Shopify'},
  {value: 'MercadoLibre', viewValue: 'MercadoLibre'}
];

  entradaDatabase: EntradaDatabase | null;
  data: EntradaIssue[] = [];

  resultsLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;
  guiaForm: FormGroup;
  keywords = "";
  url1 = "";
  url2 = "";
  url3 = "";
  url4 = "";
  url5 = "";
  url6 = "";
  url7 = "";
  url8 = "";
  url9 = "";
  url10 = "";
  url11 = "";
  url12 = "";
  spinner = false;
  input_hidden = true;


  constructor(
      private formBuilder: FormBuilder,
      private _httpClient: HttpClient,
      public dialog: MatDialog,
      private reportService: ReportService,
      private snackBar: MatSnackBar, // para confirmacion de formulario
  ) { }

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  ngOnInit() {
    this.ff_status = new FormControl('', [Validators.required]);
    this.estatus_entrada_devolucion = new FormControl('', [Validators.required]);
    this.estatus_tickets = new FormControl('', [Validators.required]);
    this.picker_inicio = "";
    this.fecha = "";
    this.picker_fin = "";
    this.nombre_seller = new FormControl('', [Validators.required]);
    this.estatus_productos = new FormControl('', [Validators.required]);
    this.estatus_stock = new FormControl('', [Validators.required]);
    this.estatus_publicacion = new FormControl('', [Validators.required]);
    this.canal_seleccionado = new FormControl('', [Validators.required]);
  }

  ngAfterViewInit() {

    this.entradaDatabase = new EntradaDatabase(this._httpClient);

    // If the user changes the sort order, reset back to the first page.
    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    // console.log("las keywords iniciales son " + this.keywords)
    this.hacerTabla(this.keywords);

  }

  setClasses() {
    
    let myClasses = {
     // retrasado: Date.parse(fecha_corte.toISOString()) > Date.parse(fecha_creado),
     // a_tiempo: Date.parse(fecha_corte.toISOString()) < Date.parse(fecha_creado),
    }

    return  myClasses
  }

  hacerTabla(filtros){
    merge(this.sort.sortChange, this.paginator.page, )
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          return this.entradaDatabase!.getRepoIssues(
            this.sort.active, this.sort.direction, this.paginator.pageIndex, filtros);
        }),
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.total_count;
          // console.log("vamos en la 72")
          // console.log(data)
         

          return data.items;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return observableOf([]);
        })
      ).subscribe(data => this.data = data);
  }


  //  PARA DIALOGO GUIAS
  openDialog(entrada_token) {
    // console.log("Entro a dialog guia")

    //// console.log(correo)
    const dialogRef = this.dialog.open(DialogReport ,{width:'450px', height: 'auto', data: {token: entrada_token}});

    dialogRef.afterClosed().subscribe(result => {
      // console.log("Cerramos el dialog");
      this.hacerTabla(this.keywords);
    });
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.keywords = filterValue.trim().toLowerCase();
    // console.log("las keywords son ")
    // console.log(this.keywords)
    this.hacerTabla(this.keywords);
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    this.fecha = event.value.toLocaleDateString('en-GB'); // British English uses day-month-year order
  }

  generarReporte(tipo){
    var fulfilled_sta = this.ff_status.value;
    var fecha_inicio = this.picker_inicio;
    var fecha_fin = this.picker_fin;
    var fecha = this.fecha;
    var estatus_entrada_devolucion = this.estatus_entrada_devolucion.value;
    var estatus_tickets            = this.estatus_tickets.value;
    //Variables productos
    var estatus_productos         = this.estatus_productos.value;
    var estatus_stock             = this.estatus_stock.value;
    //Variables publicaciones
    var estatus_publicacion       = this.estatus_publicacion.value;
    var canal_seleccionado        = this.canal_seleccionado.value;
      
    // console.log("el tipo es " + tipo)
    tipo += ''
    if(tipo == 'inventario' && fecha == ''){
      this.snackBar.open("Seleccione una fecha", "OK", {                      
        duration: 2000,
      });
    }else{
      this.spinner = true;
      this.reportService.registrar(tipo, fulfilled_sta, fecha_inicio, fecha_fin, fecha, estatus_entrada_devolucion, estatus_tickets, estatus_productos, estatus_stock, estatus_publicacion, canal_seleccionado, this.checkProductosInavtivos)
      .pipe(first())
      .subscribe(
          data => {
              this.consultarProgreso(tipo);
              this.snackBar.open("Reporte en proceso", "OK", {                      
                duration: 2000,
              });
              this.resetVars();
          },
          error => {
            //  this.error = error;
              // this.loading = false;
              // console.log("error recibido en component")
          });
    }
  }

  generarReporteInventario(tipo, fecha){
    this.spinner = true;
    tipo += ''
   this.reportService.registrarInventario(tipo, fecha)
    .pipe(first())
    .subscribe(
      data => {
         this.consultarProgreso(tipo);
         this.snackBar.open("Reporte en proceso", "OK", {                      
            duration: 2000,
          });      
      },
      error => {
      });
  }

  consultarProgreso(tipo){
    this.reportService.consultarProgreso()
    .pipe(first())
    .subscribe(
        data => {
          // console.log(tipo)
          // console.log("la data es")
          // console.log(data)
          let el_reporte = null;
          if(tipo == "ordenes"){
            el_reporte = data["body"]["items"][0]
            this.url5 = data["body"]["items"][0]["download_url"]
          }else if(tipo == "inventario"){
            el_reporte = data["body"]["items"][1]
            this.url6 = data["body"]["items"][1]["download_url"]
          }else if(tipo == "guias"){
            el_reporte = data["body"]["items"][2]
            this.url7 = data["body"]["items"][2]["download_url"]
          }else if(tipo == "devoluciones"){
            el_reporte = data["body"]["items"][3]
            this.url8 = data["body"]["items"][3]["download_url"]
          }else if(tipo == "entradas"){
            el_reporte = data["body"]["items"][4]
            this.url9 = data["body"]["items"][4]["download_url"]
          }else if(tipo == "tickets"){
          el_reporte = data["body"]["items"][5]
          this.url10 = data["body"]["items"][5]["download_url"]
        }else if(tipo == "productos"){
          el_reporte = data["body"]["items"][6]
          this.url11 = data["body"]["items"][6]["download_url"]
        }else if(tipo == "publicaciones"){
          el_reporte = data["body"]["items"][7]
          this.url12 = data["body"]["items"][7]["download_url"]
        }
        
          // console.log("el reporte es")
          // console.log(el_reporte)
          if(el_reporte){
            if(el_reporte["en_proces"] == false && el_reporte["completado"] == true){
              this.spinner = false;
              this.hacerTabla(this.keywords);
              this.snackBar.open("Reporte Completado", "OK", {                      
                duration: 2000,
              });
            }else{
              setTimeout(() => 
              {
                this.consultarProgreso(tipo);
              },
              3000);
            }
          }
        },
        error => {
        });
  }

  resetVars() {
    this.ff_status.setValue("");
    this.estatus_entrada_devolucion.setValue("");
    this.estatus_tickets.setValue("");
    this.picker_inicio = "";
    this.fecha = "";
    this.picker_fin = "";
    this.estatus_productos.setValue("");
    this.estatus_stock.setValue("");
    this.estatus_publicacion.setValue("");
    this.canal_seleccionado.setValue("");
  }

}

export interface EntradabApi {
  items: EntradaIssue[];
  total_count: number;
}

export interface EntradaIssue {
  created_at: string;
  number: string;
  state: string;
  title: string;
}

/** An example database that the data source uses to retrieve data for the table. */
export class EntradaDatabase {
  constructor(private _httpClient: HttpClient) {}

  getRepoIssues(sort: string, order: string, page: number, filtro: string): Observable<EntradabApi> {
    // console.log(sort)
    // console.log(order)
    // console.log(page)
     const href = `${environment.apiUrl}/rmsfe/query_reports.json`;
    // const href = 'http://localhost:3000/rmsfe/query_entradas.json';
    const requestUrl =
        `${href}?sort=${sort}&order=${order}&page=${page + 1}&keywords=${filtro}`;

    return this._httpClient.get<EntradabApi>(requestUrl);
  }
}



@Component({
  selector: 'reports-tab-2',
  templateUrl: './reports-tab-2.html',
  styleUrls: ['./reports.component.scss']

})
export class ReportsTab2 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'reports-tab-3',
  templateUrl: './reports-tab-3.html',
  styleUrls: ['./reports.component.scss']

})
export class ReportsTab3 implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}


@Component({
  selector: 'dialog-report',
  templateUrl: './dialog-report.html',
})
export class DialogReport {

  guiaForm: FormGroup;
  loading = false;
  submitted = false;
  returnUrl: string;
  error: string;
  la_guia: string;
  mensaje_success = false;
  guiaFormGuia: FormControl;
  formPaqueteria: FormControl;
  paqueteriaFormGuia: FormControl;
  spinner = false;
  entrada_token: string;
  keywords = "";
  otra = false;
  paqueteria: string;

  constructor(
    private formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<DialogReport>,
    private entradaService: EntradaService,
    @Inject(MAT_DIALOG_DATA) public data: any
    ){
    if(this.data.token){
      this.entrada_token = this.data.token;
      // console.log("El token es "+this.entrada_token);
    }
  }

  ngOnInit(){
    this.guiaForm = this.formBuilder.group({
      guiaFormGuia: ['', Validators.required],
    });

    this.guiaFormGuia = new FormControl('', [
      Validators.required,
    ]);

    this.formPaqueteria = new FormControl('', [
      Validators.required,
    ]);

    this.paqueteriaFormGuia = new FormControl('', [Validators.required]);
  }

  seleccionar(){
    if(this.formPaqueteria.value == "otro"){
      this.otra = true;
    }else{
      this.otra = false;
    }
  }

  guardarGuia(){
    if (this.guiaFormGuia.invalid || this.formPaqueteria.invalid || (this.otra && this.paqueteriaFormGuia.invalid)){
      // console.log("campos invalidos");
      return;
    }
    this.loading = true;
    this.spinner = true;

    this.mensaje_success = true;
    this.loading = false;
    this.spinner = false;

    // console.log(this.guiaFormGuia.value)
    // console.log(this.formPaqueteria.value)
    if(this.otra){
      this.paqueteria = this.paqueteriaFormGuia.value;
    }else{
      this.paqueteria = this.formPaqueteria.value;
    }
    this.entradaService.actualizarEntrada(this.entrada_token, this.guiaFormGuia.value, this.paqueteria)
    .pipe(first())
    .subscribe(
      data => {
        // console.log("la data es");
        // console.log(data);
        // console.log(data.status)
        // console.log(data.body["message"]);
        if(data.status == 200){
          this.mensaje_success = true;
          this.loading = false;
          this.spinner = false;
        }else{
          this.error = data.body["message"];
          this.loading = false;
          this.spinner = false;
        }
      },
      error => {
        this.error = error;
        this.loading = false;
        this.spinner = false;
   });
  }

}